var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._g(_vm._b({class:("ep-select ep-select-" + (_vm.valid ? 'valid' : 'invalid')),style:({
    height: '50px',
    borderRadius: '8px',
    boxShadow: 'none'
  }),attrs:{"items":_vm.field.choices,"loading":_vm.field.loading,"tabindex":_vm.field.tabIndex,"placeholder":_vm.field.placeholder,"outlined":"","persistent-hint":""}},'v-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }